<template>
  <feather-icon
    :icon="iconName"
    :class="iconClass"
    size="16"
    class="mr-50 section-status-icon"
  />
</template>

<script>
export default {
  name: 'SectionStatusIcon',
  props: {
    hasData: {
      type: Boolean,
      default: false,
    },
    hasErrors: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconName() {
      if (this.hasErrors) return 'AlertCircleIcon'
      if (this.hasData) return 'CheckCircleIcon'
      return 'CircleIcon'
    },
    iconClass() {
      if (this.hasErrors) return 'text-danger'
      if (this.hasData) return 'text-primary'
      return 'text-secondary'
    },
  },
}
</script>

<style scoped>
.section-status-icon {
  vertical-align: middle;
  margin-top: -2px;
}
</style>
